const algoliasearch = require('algoliasearch/lite');
const instantsearch = require('instantsearch.js').default;
const lib = require("../helpers");
/*
 * Import our config and widgets
 * Note: elementsTypes, elementsCategories, elementsTechnology are all
 * exported from ElementsSelectMenus.js
 */
import {
    generatorsCurrentRefinements,
    generatorsClearRefinements,
    generatorConfigure,
    generatorsSearchResults,
} from '../widgets/algolia/generators'

import { panelNumeric} from "../widgets/algolia/generators/tpl/panelNumeric";
import { panelRefinement } from "../widgets/algolia/generators/tpl/panelRefinement";

import { handleToggleVisibility, countDisjunctiveFacetsRefinements } from '../helpers/search'

export default class AlgoliaGenerators {
    constructor(el) {
        this.el = el
        this.setVars()
        this.init()
    }

    setVars() {
        this.appId = window.aId;
        this.apiKey = window.aKey;
        this.index = window.aGeneratorsIndex;
        this.env = window.env;
    }

    init() {
        this.searchClient()
    }

    searchClient() {
        // Start Algolia Client
        const algoliaClient = algoliasearch(this.appId,this.apiKey);
        // Build Search
        const search = instantsearch({
            indexName: this.index,
            routing: true,
            searchClient: algoliaClient,
            searchFunction(helper) {
                const hideIfNoFilters = document.querySelectorAll('[data-elements-hide-no-filter]')
                const hideIfFilter = document.querySelectorAll('[data-elements-hide-if-filter]');
                const hasRefinements = countDisjunctiveFacetsRefinements(helper.state.disjunctiveFacetsRefinements)
                if(!hasRefinements) {
                    handleToggleVisibility(hideIfNoFilters, 'hide');
                    handleToggleVisibility(hideIfFilter, 'show');
                } else {
                    handleToggleVisibility(hideIfNoFilters, 'show');
                    handleToggleVisibility(hideIfFilter, 'hide');
                }
                helper.search()
            }
        })


        const widgetContainers = Array.from(document.querySelectorAll('[data-widget-auto]'));
        const widgetInstances = widgetContainers.map(container => {
            const { widgetAuto: type, title, label: lbl, attribute: attr, items: its } = container.dataset;
            let label = lbl || title || attr;
            let attribute = attr;
            let items;

            try {
                items = JSON.parse(its || "[]");
            } catch (e) {
                console.error(`Error parsing JSON data for widget: ${e}`);
                items = [];  // Default to an empty array if parsing fails
            }

            if (type === 'numeric') {
                return panelNumeric(container, attribute, label, items);
            } else if (type === 'refinement') {
                return panelRefinement(container, attribute, label);
            } else {
                console.error(`Unknown widget type: ${type}`);
                return null;
            }
        }).filter(widget => widget !== null);

        /*
         * Add our widgets that are imported
         * from js/widgets/algolia/elements/index.js
         */
        search.addWidgets([
            generatorConfigure,
            generatorsCurrentRefinements,
            generatorsClearRefinements,
            generatorsSearchResults,
            ...widgetInstances,
        ]);

        // Start Search
        search.start();

        search.on('render', () => {
            this.testingCallback()
        });
    }

    testingCallback() {
        lib.reInitModules('GeneratorCard')
    }
}

